import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import classes from "./NoPageFoundPage.module.scss";
import PageNotFoundBg from "../../assets/images/Common/PageNotFoundBg";
import Loader from "../../components/Common/Loader/Loader";

const NoPageFoundPage = () => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [noPageFound, setNoPageFound] = useState(false);
  useEffect(() => {
    const val = setTimeout(() => {
      setNoPageFound(true);
    }, 1000);

    return () => {
      clearTimeout(val);
    };
  }, []);

  return (
    <div className={classes.noPageFoundPage}>
      {noPageFound ? (
        <>
          <PageNotFoundBg fill={colors?.theme} />
          <div className={classes.noPageFoundPage__errorMessage}>Error</div>
        </>
      ) : (
        <Loader height="50rem" width="50rem" />
      )}
    </div>
  );
};

export default NoPageFoundPage;
